import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import { api } from "../../api/httpclient";

const initialState = {
  pageLoaded: false,
  pageDisposed: true,
  processing: false,
  processingText: "",
  notifications: [],
  reports: [],
};

const homeSlice = createSlice({
  name: "home",
  initialState: initialState,
  reducers: {
    setInitialState: (state, action) => ({ ...initialState }), //no payload

    setProcessing: (state, action) => {
      const { processing = true, processingText = "" } = action.payload;

      return {
        ...state,
        processing: processing,
        processingText: processing == false ? "" : processingText,
      };
    },
    pageLoaded: (state, action) => {
      const pageState = current(state);
      if (pageState.pageDisposed) return state;

      return {
        ...state,
        pageLoaded: true,
        processing: false,
        processingText: "",
        notifications: action.payload.Notifications,
        reports: action.payload.Reports,
      };
    },

    disposePage: (state, action) => {
      if (action.payload) return { ...initialState };
      else
        return {
          ...state,
          pageDisposed: false,
        };
    },
  },
});

export default homeSlice.reducer;

export const { setInitialState, setProcessing, pageLoaded, disposePage } =
  homeSlice.actions;

export const loadPage = (t) => async (dispatch, getState) => {
  //start with initial values
  dispatch(setInitialState());

  //undispose page
  dispatch(disposePage(false));

  //show loader
  dispatch(
    setProcessing({ processing: true, processingText: t("slices.loadingPage") })
  );

  try {
    var response = await api({
      url: "dashboard/getdashboardpagedata",
      method: "post",
      data: {},
      //headers:{'h':'1'}
    });

    //i am here +. i can safely access response.data.Succeeded which is always true and response.data.Data
    if (getState().home.pageDisposed) return;

    //it's ok to dispatch here
    let data = response.data.Data;

    //transform the response
    //add the 0/None dataset

    dispatch(pageLoaded(data));

    return Promise.resolve(response);
  } catch (err) {
    //i am here => could be any error included 200 and Succeeded=false
    return Promise.reject(err);
  }
};
